// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address-autocomplete[data-v-716a89fc] {\n  position: relative;\n  min-width: 0;\n}\n.address-suggestions[data-v-716a89fc] {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  right: 0;\n  z-index: 20;\n  margin-top: 4px;\n  max-height: 320px;\n  overflow-y: auto;\n  text-align: left;\n}\n.suggestion-main[data-v-716a89fc] {\n  font-weight: 600;\n}\n.attribution[data-v-716a89fc] {\n  padding: 4px 12px 6px;\n  font-size: 12px;\n  text-align: right;\n  opacity: 0.7;\n}", ""]);
// Exports
module.exports = exports;
